// extracted by mini-css-extract-plugin
module.exports = {"quote-card-list":"_4ibZ9FPMG57MHeycCB5xM","quote-card-list__paragraph":"_3N9ONW5lj1D2e7dhwO7bJ0","preLoaderShimmer":"_1WfixauzvDpO6vU1AtFwdu"};